import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed } from '@nuxtjs/composition-api';
import { useMediaAsset, useCountryByLang } from '~/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'TopbarLanguage',
  setup(__props) {

const { getAssetUrl } = useMediaAsset();
const store = useStore();
const config = store.getters['config/getConfig'];

const currentLocale = computed(() => config.language.find((l) => l.default));
const currentLocaleCode = computed(() => currentLocale.value?.code ?? 'en');

const options = computed(() => config.languages ?? []);

const isShowed = computed(() => options.value.length > 1);

const getFlagIcon = (code: string) => {
  return `/svg/flags/${useCountryByLang(code)?.toUpperCase()}.svg`;
};

const flagBgStyle = (code: string) => {
  const img = getAssetUrl(getFlagIcon(code), {
    width: 24,
    height: 16,
  });

  return { 'background-image': `url('${img}')` };
};

return { __sfc: true,getAssetUrl, store, config, currentLocale, currentLocaleCode, options, isShowed, getFlagIcon, flagBgStyle }
}

})